import { Col, Row, Table } from 'antd';
import { Vendor } from '../../modules/vendors';
import Title from 'antd/lib/typography/Title';
import { priceToString } from '../../util/utils';
import { ColumnsType } from 'antd/lib/table';
import { Invoice } from '../../modules/invoices';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface VendorPerformanceComponentProps {
  vendor: Vendor;
}

function VendorPerformanceComponent({
  vendor,
}: VendorPerformanceComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '참여공사',
      width: '50%',
      children: [
        {
          title: '이름',
          width: '15%',
          align: 'left',
          ellipsis: true,
          render: (_, record: any) => `${record.project.name}`,
        },
        {
          title: '종료일',
          width: '10%',
          align: 'center',
          sorter: (a: Invoice, b: Invoice) =>
            a.project.endDate.localeCompare(b.project.endDate),
          render: (_, record: any) => `${record.project.endDate}`,
        },
        {
          title: '종류',
          width: '10%',
          dataIndex: ['project', 'type'],
          ellipsis: true,
          align: 'left',
        },
        {
          title: '면적(m²)',
          width: '8%',
          dataIndex: ['project', 'area'],
          align: 'right',
        },
      ],
    },
    {
      title: '공정',
      dataIndex: 'gongjong',
      align: 'center',
      width: '12%',
    },
    {
      title: '금액(원)',
      width: '18%',
      align: 'right',
      render: (_, record: any) => priceToString(record.price - record.vat),
    },
    {
      title: '총면적당 금액(원)',
      width: '18%',
      align: 'right',
      render: (_, record: any) =>
        record.project.area
          ? priceToString((record.price - record.vat) / record.project.area)
          : null,
    },
  ];

  return (
    <StyledDiv>
      <Row>
        <Col>
          <Title level={5}>공사실적</Title>
        </Col>
      </Row>
      <Row justify="space-between">
        <Col span={24}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={vendor.invoices}
            bordered
            summary={(pageData) => {
              let totalValue = 0;

              pageData.forEach(({ price, vat }) => {
                totalValue += price - vat;
              });

              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}></Table.Summary.Cell>
                    <Table.Summary.Cell index={1}></Table.Summary.Cell>
                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                    <Table.Summary.Cell index={4} align="center">
                      Total
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} align="right">
                      {priceToString(totalValue)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
              position: ['bottomCenter'],
            }}
            locale={{
              triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
              triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
              cancelSort: '정렬을 취소하려면 클릭하세요.',
            }}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default VendorPerformanceComponent;
